import React from 'react';
export const UrgencySection = () => {
  return <section className="w-full py-16 bg-red-600 text-white" data-id="element-482">
      <div className="max-w-4xl mx-auto px-4 text-center" data-id="element-483">
        <div className="animate-pulse mb-8" data-id="element-484">
          <h2 className="text-3xl md:text-5xl font-bold mb-8" data-id="element-485">
            TO MOŻE BYĆ OSTATNI DZWONEK DLA TWOJEGO MAŁŻEŃSTWA
          </h2>
        </div>
        <div className="space-y-6 mb-12" data-id="element-486">
          <div className="bg-red-700 p-4 rounded-lg transform transition-all hover:scale-105" data-id="element-487">
            <p className="text-xl flex items-center" data-id="element-488">
              <span className="mr-2 text-yellow-300" data-id="element-489">⚠️</span>
              Po którym dniu przestanie wracać o czasie?
            </p>
          </div>
          <div className="bg-red-700 p-4 rounded-lg transform transition-all hover:scale-105" data-id="element-490">
            <p className="text-xl flex items-center" data-id="element-491">
              <span className="mr-2 text-yellow-300" data-id="element-492">⚠️</span>
              Po którym dniu zauważy młodszą koleżankę z pracy?
            </p>
          </div>
          <div className="bg-red-700 p-4 rounded-lg transform transition-all hover:scale-105" data-id="element-493">
            <p className="text-xl flex items-center" data-id="element-494">
              <span className="mr-2 text-yellow-300" data-id="element-495">⚠️</span>
              Po którym dniu powie: "To już nie ma sensu"?
            </p>
          </div>
          <div className="bg-red-700 p-4 rounded-lg transform transition-all hover:scale-105" data-id="element-496">
            <p className="text-xl flex items-center" data-id="element-497">
              <span className="mr-2 text-yellow-300" data-id="element-498">⚠️</span>
              Po którym dniu twoje dzieci zapytają: "Dlaczego się rozwodzicie?"
            </p>
          </div>
        </div>
        <div className="mb-8" data-id="element-499">
          <div className="flex items-center justify-center" data-id="element-500">
            <div className="text-3xl font-mono bg-white text-red-600 px-4 py-2 rounded-lg" data-id="element-501">
              <span className="countdown" data-id="element-502">
                <span data-id="element-503">0</span>
                <span data-id="element-504">0</span>:<span data-id="element-505">0</span>
                <span data-id="element-506">0</span>:<span data-id="element-507">0</span>
                <span data-id="element-508">0</span>
              </span>
            </div>
          </div>
          <p className="mt-4 text-lg" data-id="element-509">
            Każdy dzień zwłoki = kolejny dzień w błędnym kole
          </p>
        </div>
      </div>
    </section>;
};